import BasePage from "../../../base/BasePage";
import React from "react";
import RegionTab from "../../../components/common/RegionTab";
import TrainingCost from "./training-report-table/TrainingCost";
import TrainingReportListPage from "./training-report-table/TrainingReportListPage";
import KeyPosition from "./training-report-table/KeyPosition";

class TrainingManagementReportPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      progress: false,
    };
  }

  render() {
    const tabs = [
      { title: "Training Cost", content: <TrainingCost /> },
      { title: "Training List", content: <TrainingReportListPage /> },
      { title: "Key Position Competency Profile", content: <KeyPosition /> },
    ];
    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Learning and Development &gt;
            </p>
            <p style={{ fontSize: "14px", color: "#333" }}>Training Report</p>
          </div>

          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default TrainingManagementReportPage;
